import { useCallback, useEffect, useState } from 'react'

import { getPriceHistory } from '@/api/clarityLens'
import {
  PriceHistoryMonthlyModel,
  PriceHistoryResponseModel,
} from '@/types/clarityLens'

type LineChartDataModel = {
  data: PriceHistoryMonthlyModel
}

export default function usePriceHistory(
  startDate: string,
  endDate: string,
  branches: string,
  itemName: string,
  metric: string
) {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)
  const [seasonalityChartData, setSeasonalityChartData] =
    useState<LineChartDataModel>()

  const fetchAllData = useCallback(async () => {
    if (!itemName || !startDate || !endDate || !metric) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      // Determine if metric should be passed to API
      const shouldPassMetric = metric !== 'ptiMoneyImpact'

      const response: PriceHistoryResponseModel = await getPriceHistory(
        branches,
        startDate,
        endDate,
        itemName,
        shouldPassMetric ? metric : undefined
      )

      console.log('response', response)

      // Convert seasonality to line chart
      const lineChart: LineChartDataModel = convertToLineChart(
        response.avg_material_code_price
      )
      setSeasonalityChartData(lineChart)
    } catch (err) {
      setError(
        new Error(
          err instanceof Error ? err.message : 'An unknown error occurred'
        )
      )
    } finally {
      setLoading(false)
    }
  }, [branches, startDate, endDate, itemName, metric])

  const refetch = useCallback(() => {
    console.log('Refetching price history data...')
    return fetchAllData()
  }, [fetchAllData])

  useEffect(() => {
    fetchAllData()
  }, [fetchAllData])

  return {
    seasonalityChartData,
    loading,
    error,
    refetch,
  }
}

function convertToLineChart(
  priceHistory: PriceHistoryMonthlyModel
): LineChartDataModel {
  return {
    data: priceHistory,
  }
}
